import styles from "./Sidebar.module.css";

const GROUPS = [
  {
    label: "Verification",
    items: [
      { id: "overview", label: "Overview" },
      { id: "bank", label: "Question Bank" },
      { id: "sets", label: "Sets" },
      { id: "keys", label: "Answer Key" },
      { id: "errors", label: "Errors" },
    ],
  },
  {
    label: "Treasure Hunt",
    items: [
      { id: "qr", label: "QR Map", soon: true },
      { id: "leaderboard", label: "Leaderboard", soon: true },
      { id: "participants", label: "Participants", soon: true },
    ],
  },
  {
    label: "System",
    items: [{ id: "settings", label: "Settings", soon: true }],
  },
];

export default function Sidebar({ active, errorCount, onNav }) {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.brand}>
        <span className={styles.brandName}>NSSC</span>
        <span className={styles.brandSub}>Treasure Hunt</span>
      </div>
      <nav className={styles.nav} aria-label="QA navigation">
        {GROUPS.map((group) => (
          <div key={group.label} className={styles.group}>
            <p className={styles.groupLabel}>{group.label}</p>
            {group.items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`${styles.item} ${active === item.id ? styles.active : ""}`}
                disabled={item.soon}
                aria-current={active === item.id ? "page" : undefined}
                onClick={() => onNav(item.id)}
              >
                <span className={styles.glyph} aria-hidden="true">▣</span>
                <span className={styles.itemLabel}>{item.label}</span>
                {item.id === "errors" && errorCount > 0 && (
                  <span className={styles.count}>{errorCount}</span>
                )}
                {item.soon && <span className={styles.soon}>Soon</span>}
              </button>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
}
